import TaiBaseWidget from "../base.widget";
import singleTextTemplate from './SingleText.template.html'

import useReactiveZone from "reactive-zone";


class SingleTextWidget extends TaiBaseWidget {

    zone = useReactiveZone(this);
    refInput = this.zone.useElementRef('ref.input');

    template() {
        return singleTextTemplate;
    }

    getValue() {
        return this.fieldModel.userResponse
    }
}

export default SingleTextWidget;